import {AddView_Group} from "../../../../../../../../core/gd-ui/add-view/@types"
import {ProjectSystemType} from "../../../../../../../../core/model2/project/types"
import addProjectView_tagStructure from "../config/new-tag-config"
import addView_projectConfig from "../config/new-project-views-config"
import addView_projectWorkspaceConfig from "./new-workspace-config"

export default function getNewProjectViewItemsGrouped(projectId: ID):AddView_Group[] {

    switch (gd.projectViews.project.systemType) {
        case ProjectSystemType.TAG:
            return addProjectView_tagStructure()

        case ProjectSystemType.WORKSPACE:
            return addView_projectWorkspaceConfig(projectId)

        default:
            return addView_projectConfig(projectId)
    }
}
